<template>
  <div class="container">
    <div class="card mx-auto mt-5">
      <div class="card-header">
        <strong>{{ $t('brand') }}</strong> - {{ $t('authentification.forgotPassword') }} 
      </div>
      <div class="card-body">        
        <p>{{$t('authentification.forgotPasswordInstruction')}}</p>
        <hr class="mt-4 mb-4">

        <errorMessage v-bind:message="error"></errorMessage>

        <form>
          <div class="form-group">
            <label for="inputEmail">{{ $t('authentification.email') }}</label>
            <input v-model.trim="email" v-validate="'required'" class="form-control" name="inputEmail" id="inputEmail" type="email" placeholder="Entrez votre courriel">
            <span class="text-danger" v-if="errors.has('inputEmail')">{{ $t('validations.required') }}</span>
          </div>
         
          <a @click="confirm" href="#" class="btn btn-primary btn-block">{{$t('form.confirm_button')}}</a>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {TokenAuthServiceClient, ForgotPasswordModel} from '../shared/service-clients/service-clients'
import ServiceFactory from '../shared/service-clients/serviceClientFactory'
import ErrorMessage from './ErrorMessage.vue'
import CrudMixin from '../shared/Mixin/CrudMixin'

export default {
  name: 'forgotPassword',
  mixins: [CrudMixin],
  data() {
    return {
      error: '',
      email: '',
    }
  },
  methods: {
    confirm: function() {
      this.$validator.validateAll().then(result => {
        if (result) {
          let TokenAuthService = ServiceFactory.create(TokenAuthServiceClient)

          TokenAuthService.forgotPassword(new ForgotPasswordModel({emailAddress: this.email}))
            .then(res => {
              this.$swal(this.$i18n.t('success'), this.$i18n.t('authentification.forgotPasswordSuccessMessage'), 'success')
              this.$router.push({path: '/login'})
            })
            .catch(err => {
              this.processError(err, this)
            })
        }
      })
      è
    },
    fetchData: function() {},
  },
  components: {
    errorMessage: ErrorMessage,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue